import { render, staticRenderFns } from "./ReviewsDisplayServiceResults.vue?vue&type=template&id=6acbbf0c&"
import script from "./ReviewsDisplayServiceResults.vue?vue&type=script&lang=js&"
export * from "./ReviewsDisplayServiceResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports